
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 27 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0D5EAF","d":"M0 0h27v18H0z"}}),_c('path',{attrs:{"fill":"none","stroke-width":"2","stroke":"#FFF","d":"M5 0v11M0 5h10m0-2h17M10 7h17M0 11h27M0 15h27"}})])
          )
        }
      }
    